module.exports = __webpack_public_path__ + "img/17.6ce29e4f.jpg";